import React, { Component } from "react";
import { withRouter } from "react-router";

class OrderDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            shipped: {},
            loaded: false,
            placeholder: "Loading",
        };
    }
    componentDidMount() {
        const id = this.props.match.params.id;
        console.log(id);
        fetch("/api/OrderDetail/"+id)
        .then((response) => {
            if (response.status > 400) {
                return this.setState(() => {
                    return { placeholder: "Something went wrong!" };
                });
            }
            return response.json();
        })
        .then((data) => {
            let shipped={};
            data.order.fulfillments.map(s=> {
                s.line_items.map(i=>{
                    if (shipped.hasOwnProperty(i.name)) {
                        shipped[i.name]++;
                    } else {
                        shipped[i.name]=0;
                    }
                });
            });
            console.log(data.order);
            this.setState(() => {
                return {
                    data: data.order,
                    shipped,
                    loaded: true,
                };
            });
        });
    }
    render() {
        if (this.state.loaded) {
            return (
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Product ID</th>
                            <th>Item Number</th>
                            <th>Product</th>
                            <th>Price</th>
                            <th>Quantity Ordered</th>
                            <th>Quantity Shipped</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.data.line_items.map((item, idx) => {
                            return (
                                <tr>
                                    <td>{item.product_id}</td>
                                    <td>{item.variant_title}</td>
                                    <td>{item.title}</td>
                                    <td>{item.price}</td>
                                    <td>{item.quantity}</td>
                                    <td>{this.state.shipped[item.name]}</td>
                                    <td>{item.quantity*item.price}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            );
        } else {
            return (<div>Loading...</div>);
        }
    }
}
export default withRouter(OrderDetail);

